// src/store/pipeline.js

const SET_FINANCING_REQUESTS = "SET_FINANCING_REQUESTS";
const CLEAR_FINANCING_REQUESTS = "CLEAR_FINANCING_REQUESTS";
const ADD_FINANCING_REQUEST_TO_BEGINNING = "ADD_FINANCING_REQUEST_TO_BEGINNING";
const ADD_FINANCING_REQUEST_TO_END = "ADD_FINANCING_REQUEST_TO_END";

// -- Initial State --
const initialState = null;

// -- Reducer --
export default function financingRequestsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FINANCING_REQUESTS:
      return action.payload;

    case CLEAR_FINANCING_REQUESTS:
      return initialState;

    case ADD_FINANCING_REQUEST_TO_BEGINNING:
      return [action.payload, ...(state || [])];

    case ADD_FINANCING_REQUEST_TO_END:
      return [...(state || []), action.payload];

    default:
      return state;
  }
}

// — action creators —

export const financingRequestsSet = (payload) => ({
  type: SET_FINANCING_REQUESTS,
  payload,
});

export const financingRequestsClear = () => ({
  type: CLEAR_FINANCING_REQUESTS,
});

export const financingRequestAddToBeginning = (payload) => ({
  type: ADD_FINANCING_REQUEST_TO_BEGINNING,
  payload,
});

export const financingRequestAddToEnd = (payload) => ({
  type: ADD_FINANCING_REQUEST_TO_END,
  payload,
});
